import React, { useState } from 'react'
import Script from 'react-load-script'
import { GOOGLE_MAPS_API } from '../../Constants'

interface Props {
  children: any
}
const GoogleScript: React.FC<Props> = ({ children }): JSX.Element => {
  const [loaded, setLoaded] = useState(false)
  const language = document.documentElement.lang

  return (
    <>
      <Script
        attributes={{ id: 'googleMaps' }}
        onLoad={() => setLoaded(true)}
        url={`${GOOGLE_MAPS_API}${language}`}
      />

      {loaded && children}
    </>
  )
}

export default GoogleScript
